const TermsConditionsEn = () => {
  return (
    <div>
      <p>
        By signing these Rules, you declare and confirm that you fully and
        unconditionally agree with the conditions defined in these Rules and
        accept those conditions.
      </p>
      <p className="mt-[10px]">
        <span className="mt-[10px] text-[20px] font-semibold">
          1. BASIC DEFINITIONS
        </span>{' '}
        <br /> The main definitions used in these Rules and their meanings are
        as follows: <br /> <span className="font-semibold">Company</span> –
        “DIGERA” Limited Liability Company (TIN: 2007374731), which is the owner
        of “invoice-reporter.com” and organizes and ensures its management.{' '}
        <br />
        <span className="font-semibold"> “invoice-reporter.com”</span> – is
        software that includes the entry of data on income and expenses,
        operators, managers, operators and projects, the preparation of reports
        in online mode, the preparation of invoices (invoices) and sending them
        to customers, the regulation of all stages of banking operations from
        the beginning to the end, information related to customers, notes and
        tasks about them, and user activity. <br />
        <span className="font-semibold">User</span> – any person (legal or
        natural) using “invoice-reporter.com”. <br />{' '}
        <span className="font-semibold"> Personal data</span> – any information
        of a personal nature that allows direct or indirect identification of
        the user. <br /> <span className="font-semibold">Website</span> –
        www.invoice-reporter.com Mobile application (app): a mobile application
        downloaded from the App Store and Play Market under the name
        “invoice-reporter.com”. <br />{' '}
        <span className="font-semibold">Registration</span> – the process that
        allows the use of “invoice-reporter.com” by entering personal data and
        agreeing with these Rules. <br />{' '}
        <span className="font-semibold">Account</span> – a page that reflects
        information about the User and allows the use of “invoice-
        reporter.com”. <br /> <span className="font-semibold">Tariff</span> –
        the amount of money determined exclusively by the Company for the use of
        “invoice- reporter.com”. These Rules define the rules and conditions of
        using “invoice-reporter.com” and regulate the legal relations between
        the Company and the User.
      </p>
      <p className="mt-[10px]">
        These Rules define the rules and conditions of using
        “invoice-reporter.com” and regulate the legal relations between the
        Company and the User.
      </p>
      <p className="mt-[10px]">
        <span className="text-[20px] font-semibold">
          2. REGISTRATION ON “invoice-reporter.com”
        </span>{' '}
        <br />
        To use “invoice-reporter.com”, first of all the User must register
        through the website. After entering the relevant information and
        completing the necessary steps, an individual account will be created
        for the User and the User may independently add information to the
        account and manage the account. An account is created only when all
        information is entered correctly and in accordance with the relevant
        user instructions. The User bears responsibility for the accuracy of the
        information entered during registration and for the regular updating of
        changes in the information belonging to the User after registration. If
        it is determined that the information entered by the User during
        registration is incorrect, fake or false, and there are reasonable
        suspicions regarding this, the Company has the right to restrict, block,
        delete the User’s account and prohibit the use of
        “invoice-reporter.com”. Also, if deemed necessary, the Company may
        provide the information required for the investigation of the fact of
        false registration to Law Enforcement Authorities. In accordance with
        the requirements of the legislation of the Republic of Azerbaijan,
        “invoice- reporter.com” collects and processes only personal data
        entered by the User. By entering personal data, the User is considered
        to have given consent to the collection and processing of such data by
        “invoice-reporter.com”. When using “invoice-reporter.com”, the User
        bears responsibility for the consequences of his/her actions or inaction
        (entering third-party accounts under any circumstances or allowing third
        parties to use his/her account, etc.), as well as for failure to
        maintain the confidentiality of information.
      </p>
      <p className="mt-[10px]">
        <span className="text-[20px] font-semibold">
          3. LOGIN (E-MAIL) AND PASSWORD
        </span>{' '}
        <br />
        When registration on “invoice-reporter.com” is successfully completed, a
        personal account will be created for the User. During registration, the
        User must choose a login (e-mail) and password determined by
        himself/herself to access the account. The Company may prohibit the use
        of certain logins, as well as set certain necessary requirements for the
        password (number and quantity of characters to be used, etc.). The login
        (e-mail) and password chosen by the User are important and confidential
        information. Keeping them confidential is the responsibility of the User
        and serves to protect his/her interests. In order to ensure the security
        of your account, at the end of each session performed with
        “invoice-reporter.com”, you are required to independently log out of
        your account (via the “logout” button). Otherwise, the Company shall not
        be responsible for the loss of data in “invoice-reporter.com” and any
        other possible negative consequences. If the User detects or suspects
        that access to the account has been restricted, as well as that the
        confidentiality of the password has been violated, he/she must
        immediately notify the Company. The prompt reaction of the User in such
        cases helps the Company to effectively implement security measures.
      </p>
      <p className="mt-[10px]">
        <span className="text-[20px] font-semibold">
          4. ACCOUNT RESTRICTION AND DELETION
        </span>{' '}
        <br />
        If the User violates the terms of these Rules, the Company, exercising
        its exclusive powers, may, without stating the reasons, restrict, block,
        delete the User’s account, including all content, and prohibit its use.
        From that moment, the use of the User’s account and the data contained
        in the account, restoration of the use of the account, restoration of
        the account, and restoration of the data contained in the account shall
        not be possible.
      </p>
      <p className="mt-[10px]">
        <span className="text-[20px] font-semibold">5. PAYMENT TERMS</span>{' '}
        <br />
        The use of “invoice-reporter.com” is paid. The Company may provide the
        first 90 (ninety) days of use of “invoice-reporter.com” free of charge
        as a trial period. After the trial period ends, in order to use
        “invoice-reporter.com”, payment must be made in accordance with the
        tariff schedule and payment conditions posted on the Company’s website.
        Changing the amount of the fee payable for the use of
        “invoice-reporter.com” in the tariff schedule and making additions to it
        is the exclusive right of the Company. By choosing a tariff suitable for
        him/her, the User undertakes the obligation to pay for the use of
        “invoice-reporter.com”. The User must make the payment for the use of
        “invoice-reporter.com” on time and in full. If payments are made late or
        incompletely, the User’s right to use “invoice-reporter.com” will be
        restricted. Payment may be made via our website, by bank cards (VISA /
        MasterCard and others) and by transferring funds to the Company’s
        settlement account.
      </p>
      <p className="mt-[10px]">
        <span className="text-[20px] font-semibold">
          6. PROTECTION OF INTELLECTUAL PROPERTY AND OTHER RIGHTS
        </span>{' '}
        <br />
        The rights to the “invoice-reporter.com” software belong to the Company.
        The Company retains all rights expressed or not expressed in these
        Rules. By agreeing to these Rules, the User does not purchase
        “invoice-reporter.com”, but only obtains the right to use it.
      </p>
      <p className="mt-[10px]">
        <span className="text-[20px] font-semibold">
          7. RESTRICTION OF USER RIGHTS
        </span>{' '}
        <br />
        The User may not copy the software, reproduce it, decompose it into
        components, disassemble it or attempt to discover the source code or
        algorithms of the software, change any feature of the software, carry
        out cyber-attacks on it for the purpose of rendering it unusable, or use
        the software for other purposes. The User may not provide the software
        for use to third parties. If the Company observes any illegal use by the
        User, it may restrict the User’s use of “invoice- reporter.com” and
        terminate the account without refunding any amount and without sending
        any additional notice.
      </p>
      <p className="mt-[10px]">
        <span className="text-[20px] font-semibold">8. USER OBLIGATIONS</span>{' '}
        <br />
        The User bears personal responsibility for the use of the account. The
        Company does not conduct investigations or checks regarding the
        information placed in the account or transmitted through the
        “invoice-reporter.com” system. The User bears responsibility for the
        submission of information and for using “invoice- reporter.com” in
        accordance with the legislation. By accepting the use of
        “invoice-reporter.com”, the User unconditionally agrees that he/she will
        comply with the legislation of the Republic of Azerbaijan when using
        “invoice-reporter.com”. The User bears personal responsibility for any
        illegal actions committed during the use of “invoice-reporter.com”.
      </p>
      <p className="mt-[10px]">
        <span className="text-[20px] font-semibold">
          9. CONSENT TO USE OF DATA
        </span>{' '}
        <br />
        The User accepts and confirms that when using “invoice-reporter.com”,
        he/she transfers his/her personal data to the server. The Company
        ensures the transfer and processing of personal data in compliance with
        the requirements of the legislation on personal data protection. The
        User also accepts and confirms that he/she does not object to the
        storage of his/her data on international servers located outside the
        territory of the Republic of Azerbaijan. When using
        “invoice-reporter.com”, the User unconditionally gives consent to the
        processing of personal data belonging to him/her (recording,
        systematization, updating, modification, extraction, storage, transfer,
        destruction, etc.). The User’s data may be stored in “clouds” located in
        foreign countries. The User unconditionally agrees to the cross-border
        transfer of personal data and to their placement, storage and processing
        in clouds located in foreign countries.
      </p>
      <p className="mt-[10px]">
        <span className="text-[20px] font-semibold">10. WARRANTY</span> <br />
        The Company bears responsibility for the protection and storage of all
        information entered by the User in connection with the use of
        “invoice-reporter.com”. The Company’s liability to the User for damage
        caused to the User as a result of using “invoice- reporter.com” may not
        exceed the amount paid by the User to the Company.
      </p>
      <p className="mt-[10px]">
        <span className="text-[20px] font-semibold">
          11. LIMITATION OF LIABILITY
        </span>{' '}
        <br />
        The Company bears no responsibility for any damage arising as a result
        of using or inability to use “invoice-reporter.com”, as well as errors
        that may occur during the use of the program or damages, deficiencies,
        external interference, defects, delays in operation or transmission,
        computer viruses, inability to connect. The Company bears no
        responsibility for operations carried out on the basis of false or fake
        data. The Company bears no responsibility for the correctness of
        documents (reports, invoices, banking documents, etc.) prepared in
        “invoice-reporter.com”. The Company bears no responsibility for damage
        caused as a result of any incorrect data entered by you during the
        preparation of documents.
      </p>
      <p className="mt-[10px]">
        <span className="text-[20px] font-semibold">
          12. UPDATES AND CONFIGURATIONS
        </span>{' '}
        <br />
        The Company may carry out updates, configurations, improvements and
        other necessary works in “invoice-reporter.com” on a regular basis in
        order to ensure its continuous and quality operation. New functions may
        be added to the updated “invoice-reporter.com” and in some cases
        existing functions may be removed.
      </p>
      <p className="mt-[10px]">
        <span className="text-[20px] font-semibold">
          13. TRANSFER TO THIRD PARTIES
        </span>{' '}
        <br />
        The User may not transfer the rights granted to him/her for the use of
        “invoice-reporter.com” or other related software to third parties in any
        case and in any form.
      </p>
      <p className="mt-[10px]">
        <span className="text-[20px] font-semibold">
          14. APPLICABLE LAW AND DISPUTE RESOLUTION
        </span>
        <br />
        These Rules are governed by and interpreted in accordance with the
        legislation of the Republic of Azerbaijan. All disputes arising from
        these Rules related to “invoice-reporter.com” or in connection with it,
        if they cannot be resolved through negotiations between the parties,
        shall be resolved by the relevant courts of the Republic of Azerbaijan
        in accordance with the legislation of the Republic of Azerbaijan.
      </p>
    </div>
  );
};

export default TermsConditionsEn;
